module.exports = __webpack_public_path__ + "img/palace.44965baf.jpg";